import * as Yup from 'yup';
export const schema = Yup.object().shape({
  price: Yup.number()
    .required('قیمت پایه ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
  duration: Yup.number()
    .required('مدت زمان مزایده ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
});
